import React from "react";

const TermsOfUse = () => {
  return (
    <>
      <section
        style={{
          paddingTop: "108px",
          background: "linear-gradient(135deg, #1f3c88 0%, #39a0ed 100%)",
        }}
      >
        <div className="auto-container">
          <div style={{ padding: "42px 0 36px", textAlign: "center", color: "#ffffff" }}>
            <h1 style={{ fontSize: "40px", fontWeight: 700, marginBottom: "8px", color: "#ffffff" }}>
              Terms of Use - Asysta India Private Limited
            </h1>
          </div>
        </div>
      </section>

      <section
        style={{
          background: "linear-gradient(180deg, #eef4ff 0%, #ffffff 100%)",
          padding: "42px 0 80px",
        }}
      >
        <div className="auto-container">
          <div
            style={{
              maxWidth: "980px",
              margin: "0 auto",
              background: "#ffffff",
              borderRadius: "14px",
              boxShadow: "0 12px 30px rgba(15, 39, 73, 0.10)",
              border: "1px solid #e4ebf7",
              padding: "38px 32px",
              color: "#2a2a2a",
              lineHeight: "1.75",
            }}
          >
            <p style={{ marginBottom: "14px", color: "#5c6675", fontWeight: 600 }}>Last Updated: [28/05/2026]</p>
            <p>Welcome to Asysta ("Company", "we", "our", "us"). These Terms of Use ("Terms") govern your access to and use of our website <a href="https://www.asysta.in" target="_blank" rel="noreferrer">www.asysta.in</a> ("Website") and all related services, features, tools, and applications ("Services").</p>
            <p>By accessing or using our Website, you agree to be bound by these Terms. If you do not agree, please discontinue use immediately.</p>

            <p><strong>1. Eligibility</strong><br />
              You must be at least 18 years old to use our Services. Users under 18 may use the Website only under the supervision of a parent or legal guardian.
            </p>

            <p><strong>2. About Asysta</strong><br />
              Asysta is an online platform that enables users to:<br />
              Find, compare, and book driving courses<br />
              Connect with verified driving schools<br />
              Access mock tests and educational content<br />
              Receive recommendations for driving-related services and accessories<br />
              Asysta is not a driving school. All training services are provided by independent third-party driving schools ("Service Providers") with whom we have formal partnerships.
            </p>

            <p><strong>3. User Accounts</strong><br />
              To access certain features, users must create an account.<br />
              By creating an account, you agree to:<br />
              Provide accurate and complete information<br />
              Keep your login credentials confidential<br />
              Be responsible for all activities under your account<br />
              We reserve the right to suspend or terminate accounts that violate these Terms.
            </p>

            <p><strong>4. Payments</strong><br />
              Asysta allows users to make payments for driving courses or related services through third-party payment gateways.<br />
              By making a payment, you agree that:<br />
              Pricing displayed at the time of booking is final<br />
              Payment processing is handled by third-party providers<br />
              Asysta is not responsible for payment failures, delays, chargebacks, or gateway errors<br />
              Refunds and cancellations are governed by the respective driving school's policy, unless otherwise stated.
            </p>

            <p><strong>5. Location Data</strong><br />
              To provide accurate recommendations and nearby driving school options, Asysta may collect:<br />
              Approximate or precise location<br />
              IP-based location<br />
              User-submitted location (city, area, PIN code)<br />
              Location data is used solely to improve service accuracy and user experience.
            </p>

            <p><strong>6. Relationship with Driving Schools</strong><br />
              Asysta partners with driving schools to list their services on the platform. However:<br />
              Driving schools operate independently<br />
              Asysta does not control training quality, instructor behaviour, or vehicle condition<br />
              Scheduling, availability, and pricing are determined by the driving school<br />
              Any disputes related to training must be resolved directly with the respective driving school.
            </p>

            <p><strong>7. User Responsibilities</strong><br />
              By using our Website, you agree NOT to:<br />
              Provide false or misleading information<br />
              Attempt to disrupt or hack the Website<br />
              Use bots, scrapers, or automated tools<br />
              Misuse contact information of driving schools or other users<br />
              Upload harmful, illegal, or abusive content<br />
              Violation may result in account suspension or legal action.
            </p>

            <p><strong>8. Intellectual Property</strong><br />
              All content on the Website-including text, graphics, logos, icons, videos, and software-is the property of Asysta or its licensors.<br />
              You may not:<br />
              Copy<br />
              Reproduce<br />
              Modify<br />
              Distribute<br />
              Sell<br />
              Create derivative works<br />
              ...without our written permission.
            </p>

            <p><strong>9. Educational Content &amp; Mock Tests</strong><br />
              Asysta provides mock tests and learning material for informational purposes only.<br />
              We do not guarantee:<br />
              Passing of any government driving or learner's licence exam<br />
              Accuracy of government rules or RTO procedures<br />
              Acceptance of any content by official authorities<br />
              Users should verify official rules with their local RTO.
            </p>

            <p><strong>10. Third-Party Services</strong><br />
              Our Website may integrate with:<br />
              Payment gateways<br />
              Analytics tools<br />
              Communication tools (e.g., WhatsApp)<br />
              Mapping/location services<br />
              These third-party services operate independently and have their own terms and privacy policies.
            </p>

            <p><strong>11. Limitation of Liability</strong><br />
              To the maximum extent permitted under Indian law, Asysta is not liable for:<br />
              Any direct, indirect, incidental, or consequential damages<br />
              Loss of data, revenue, or business<br />
              Issues arising from third-party driving schools<br />
              Payment gateway errors<br />
              Service interruptions, bugs, or downtime<br />
              Your sole remedy is to stop using the Website.
            </p>

            <p><strong>12. Disclaimer of Warranties</strong><br />
              Our Website and Services are provided "as is" and "as available" without warranties of any kind.<br />
              We do not guarantee:<br />
              Accuracy or completeness of information<br />
              Continuous availability<br />
              Error-free operation<br />
              Performance of third-party driving schools<br />
              Use of the Website is at your own risk.
            </p>

            <p><strong>13. Changes to These Terms</strong><br />
              We may update these Terms at any time. Changes will be posted on this page with an updated "Last Updated" date.<br />
              Continued use of the Website means you accept the updated Terms.
            </p>

            <p><strong>14. Governing Law &amp; Jurisdiction</strong><br />
              These Terms are governed by the laws of India. Any disputes shall be subject to the exclusive jurisdiction of the courts in [Haryana, Sonipat], India.
            </p>

            <p><strong>15. Contact Us</strong><br />
              For questions or concerns regarding these Terms, contact us at:<br />
              <i className="fas fa-envelope" aria-hidden="true" style={{ marginRight: "6px" }}></i>
              <a href="mailto:info@asysta.in">info@asysta.in</a>
              <span style={{ display: "inline-block", width: "14px" }}></span>
              <i className="fas fa-globe" aria-hidden="true" style={{ marginRight: "6px" }}></i>
              <a href="https://www.asysta.in" target="_blank" rel="noreferrer">www.asysta.in</a>
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default TermsOfUse;
